export class UserSearchModel {
    _id: string;
    name: string;
    username: string;
    type: Array<String> = [];
    division: Array<String> = [];
    active: boolean;
    isDefaultSignerConsultant: boolean;
    isDefaultSignerCompany: boolean;
    secondaryDivisions: Array<String> = [];
    skip: number = 0;
    limit: number = 10;
    totalItems: number = 0;

    loadUserDataForGrid(r: any) {
        this._id = r._id ? r._id : '';
        this.name = r.name ? r.name : '';
        this.username = r.username ? r.username : '';
        this.type = r.type ? r.type : '';
        this.division = r.division ? r.division : '';
        this.active = r.active ? r.active : '';
        this.isDefaultSignerConsultant = r.isDefaultSignerConsultant ? r.isDefaultSignerConsultant: '';

    }
}



// WEBPACK FOOTER //
// ./src/app/models/UserSearch.model.ts